var heading_default = {
  "fontElementMap": "n-6QD",
  "elementSpacing": "el-80",
  "headerOne": "Vm6Bp el-80",
  "headerTwo": "mp1rj el-80",
  "headerThree": "-ul9- el-80",
  "headerFour": "-YVdl el-80",
  "headerFive": "F2ryV el-80",
  "headerSix": "Kg2IN el-80",
  "child": "e6g0h"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
